import React, { useCallback } from 'react'
import {
    Card, CardBody, CardHeader, CardIcon, CardTitle,
    GridContainer,
    GridItem,
    Icons, Table
} from '@fabricks/ui-components'
import { useKeycloak } from "react-keycloak";
import { useHistory } from "react-router-dom";
import { StorageconfigsTable } from "../Storageconfigs/StorageconfigsTable";
import Navigation from "../../constants/navigation";

interface StorageconfigsPageProps {
}

export const Storageconfigs: React.FC = (props: StorageconfigsPageProps) => {
    const [keycloak] = useKeycloak()
    const history = useHistory()

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <StorageconfigsTable />
            </GridItem>
        </GridContainer>
    )
}
